/* eslint-disable */

/**
  * <ToolbarItem />
  */

import React from 'react';
import { DragSource } from 'react-dnd';
import { v4 as uuidv4 } from 'uuid';
import ItemTypes from './ItemTypes';

const cardSource = {
  beginDrag(props) {
    return {
      id: uuidv4(),
      index: -1,
      data: props.data,
      onCreate: props.onCreate,
    };
  },
};

class ToolbarItem extends React.Component {
  render() {
    const { connectDragSource, data, onClick } = this.props;
    if (!connectDragSource) return null;
    return (
      connectDragSource(
        <li onClick={onClick}><i className={data.icon}></i>{data.name}</li>,
      )
    );
  }
}

export default DragSource(ItemTypes.CARD, cardSource, connect => ({
  connectDragSource: connect.dragSource(),
}))(ToolbarItem);
